<template>


    <div v-if="dissave" style="position:absolute; top: 300px;   width: 100%; z-index:100;  ">
        <Circle4 size="120px" class="mx-auto"></Circle4>
    </div>



    <div class="col mb-4 p-3">
        <div class="card border-left-primary shadow h-100 py-2 p-3">

            <h3 class="font-weight-bold text-primary">Рӯйхати хоҷагиҳои китоби {{ this.$store.state.book.Number }},
                {{ this.$store.state.book.Name }}</h3>

            <p>
                <button asp-action="Create" class="btn btn-outline-success" @click="createHH">Тартибдиҳӣ</button>

                <button @click="fetchHousehold" class="btn btn-outline-secondary">Обновить</button>
            </p>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>
                            #
                        </th>

                        <th>
                            Ному насаби сардори хоҷагӣ
                        </th>
                        <th>
                            Суроға
                        </th>
                        <th>
                            Суратҳисоб
                        </th>

                        <th>
                            Китоб
                        </th>
                        <th>
                            Саҳифа
                        </th>
                        <th>
                            Шумораи аҳолӣ
                        </th>
                        <th>
                            аз он маъюб
                        </th>
                        <th>
                            Гурӯҳи хоҷагӣ
                        </th>

                        <th></th>
                    </tr>
                </thead>
                <tbody>

                    <tr v-for="h in this.$store.state.households" :key="h.ID">
                        <td>
                            {{ h.ID }}
                        </td>
                        <td>
                            {{ h.Head }}
                        </td>
                        <td>
                            {{ h.Address }}
                        </td>
                        <td>
                            {{ h.Account }}
                        </td>
                        <td>
                            {{ h.Nbook }}
                        </td>
                        <td>
                            {{ h.Npage }}
                        </td>
                        <td>
                            {{ h.Col }}
                        </td>
                        <td>
                            {{ h.Invalid }}
                        </td>
                        <td>
                            {{ h.Category }}
                        </td>
                        <td>
                            <button @click="editHH(h)" class="btn btn-primary">Тағирдиҳӣ</button> &nbsp;
                            <button @click="deleteHH(h)" class="btn btn-danger">Нобудкунӣ</button>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>


    <router-view></router-view>



    <modal v-if="isModalVisible" @close="closeModal">

        <template v-slot:header>

            <h3 class="text-danger">Иштибоҳ!</h3>

        </template>

        <template v-slot:body>

            {{ errormsg }}

        </template>

    </modal>



    <mod v-if="isShowRep" @close="closemod" @scroll="scrollmod">

        <template v-slot:body>
            <member :id="idrep" ref="repComponent" @close="closemod"></member>
        </template>

    </mod>

</template>

<script>
import mod from './ModalForm.vue'
import modal from "./Modal2"
import member from './Members2.vue'

export default {
    name: 'Households',
    components: { modal, mod, member },
    data() {
        return {
            dissave: false,
            errormsg: '',
            isModalVisible: false,
            isShowRep: false,
            isShowPrint: false,
            idrep: 0,

        }
    },

    methods: {

        fetchHousehold() {
            this.dissave = true;
            console.log('start2');
            console.log('book', this.$store.state.book);

            if (this.$store.state.book == '' && this.$store.state.books.length > 0) {
                this.$store.state.book = this.$store.state.books[0];

                console.log('book2', this.$store.state.book);
            }
            console.log('book2', this.$store.state.book);

            if (this.$store.state.book != '') {
                this.$api("/api/data/2/" + this.$store.state.book.ID)
                  //  .then(res => res.json())
                    .then(data => this.$store.state.households = data)
                    .catch(error => {
                        console.error("There was an error!", error)
                    });

                console.log('stop2', this.$store.state.households);
            }

            this.dissave = false;
        },
        showModal(t) {
            this.isModalVisible = true;
            this.errormsg = t;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        pushHH(h) {
            console.log('hh', h);

            this.$store.state.household = h;
            this.$router.push('/Members')

        },

        createHH() {

            if (this.$store.state.book.ID > 0) {
                this.$store.state.household = { ID: -9, Idbook: this.$store.state.book.ID };
                this.$router.push('/Members')
            }
            else
                this.showModal('Аввал китоби лозимиро интихоб кунед');

        },


        async editHH(h) {
            console.log("edit id=", h);
            this.$store.state.household=h;
            this.idrep = h.ID;
            this.isShowRep = true;
        },

        closemod() {
            this.isShowPrint = false;
            this.isShowRep = false;
        },

        scrollmod() {
            this.$refs.repComponent.onScroll()
            //  console.log('modal scrolled')
        },

        deleteHH(h) {

            this.$api( "/api/data/" + h.ID, {
                method: 'delete',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }

                //body: JSON.stringify(this.$store.state.book)
            })
           //     .then(res => res.json())
                .then(data => this.$store.state.households = data)
                .catch(error => {
                    console.error("There was an error!", error)
                });

        }

    },

    mounted() {
        console.log('mounted', this.$store.state.households.length)

        //if (!this.$store.state.households.length>0)
        {
            console.log('updating HH')
            this.fetchHousehold();
            console.log('update HH')
        }


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
